import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f12854c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Informieren", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "postitle" }, "Beim thingTAG-Spiel bekommst Du immer kurze Informationen zu den Dingen. Wer es genauer wissen will, kann hier weiterlesen:", -1))
const _hoisted_3 = {
  key: 0,
  class: "infotexts"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_multi_item_list_loader = _resolveComponent("multi-item-list-loader")!
  const _component_infotext_description_page = _resolveComponent("infotext-description-page")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_long_text = _resolveComponent("long-text")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        canGoBack: false,
        title: _ctx.$t('message.explore')
      }, null, 8, ["title"]),
      (!_ctx.isReady)
        ? (_openBlock(), _createBlock(_component_ion_content, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        "size-xs": "12",
                        "size-sm": "12",
                        "size-md": "12",
                        "size-lg": "6"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.infotextId)
                            ? (_openBlock(), _createBlock(_component_multi_item_list_loader, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_infotext_description_page, { key: 1 }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_grid, { class: "ion-padding" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                    default: _withCtx(() => [
                      (_ctx.categories.length > 0 && !_ctx.infotextId)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            "size-xs": "12",
                            "size-sm": "12",
                            "size-md": "12",
                            "size-lg": "6"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1,
                              _hoisted_2,
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                                      _createVNode(_component_ion_label, { class: "ion-text-start ion-text-uppercase" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(category?.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (category && category.infotexts?.length > 0)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category?.infotexts, (infotext) => {
                                              return (_openBlock(), _createElementBlock("li", {
                                                key: infotext,
                                                onClick: 
                      () => {
                        _ctx.router.push('/explore/' + infotext.id);
                      }
                    
                                              }, [
                                                _createTextVNode(_toDisplayString(infotext.title) + " ", 1),
                                                _createVNode(_component_ion_icon, { icon: _ctx.arrowForwardOutline }, null, 8, ["icon"])
                                              ], 8, _hoisted_4))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_long_text, {
                            key: 1,
                            infotext: _ctx.infotext ? _ctx.infotext : {},
                            workObjectId: _ctx.workObjectId
                          }, null, 8, ["infotext", "workObjectId"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      _createVNode(_component_side_menu, {
        onOnTagObject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTagging(_ctx.workObjectId))),
        showGoBack: true,
        showTagObject: _ctx.infotextId
      }, null, 8, ["showTagObject"])
    ]),
    _: 1
  }))
}